'use strict';

var style = require('./style');

module.exports = style({
  prop: 'letterSpacing',
  key: 'letterSpacings',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/~/styled-system/dist/letter-spacing.js
// module id = 85
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141